// 全局消息中心提醒
import { getUnReadMsgCount } from '@/api/common'

export default {
  namespaced: true,
  state: {
    infoNum: '' || 0
  },
  mutations: {
    SET_INFO_NUM: (state, data) => {
      state.infoNum = data
    }
  },
  actions: {
    async setInfoNum ({ commit }) {
      try {
        const { code, result } = await getUnReadMsgCount()
        if( code !== 200) return
        commit('SET_INFO_NUM', result)
      } catch (e) {
        console.log(e)
      }
    }
  }
}